import React from 'react'

interface ResultsInfoProps {
  totalShown: number
  totalAll: number
  viewMode: 'grid' | 'list'
}

const ResultsInfo: React.FC<ResultsInfoProps> = ({ totalShown, totalAll, viewMode }) => {
  return (
    <div
      className="d-flex justify-content-between align-items-center mb-3 text-secondary"
      role="status"
    >
      <span>
        Showing <span className="fw-semibold text-white">{totalShown}</span> of{' '}
        <span className="fw-semibold text-white">{totalAll}</span> models
      </span>
      <span className="small text-muted">{viewMode === 'grid' ? 'Grid View' : 'List View'}</span>
    </div>
  )
}

export default ResultsInfo
